import { useContext } from "react";
import ConfirmDialogContext from "../context/ConfirmDialogContext";

const useConfirm = () => useContext(ConfirmDialogContext);
export default useConfirm;
